// Texts for the header
const header = {
    logoAlt: 'Logo',

    searchBarPlaceholder: 'Buscar...',

    homeLink: 'Inicio',
    productLink: 'Productos',
    aboutLink: 'Sobre nosotros',
    statisticsLink: 'Estadística',

    LogoutButtonText: 'Desconexión',
};

export default header;
